import LayoutNode, { getNodeStyleAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { AttributeTargetType} from "../Data/WBData";
import { UpdateStyleFunction } from "../Stylebuilder";
import { GetGridAreaDataFromNode, GetGridAreaDataFromStr, GetGridRenderData } from "../Utilities/GridUtils";

import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import { gridAttributes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import { useRef, useState } from "react";
import { GetScreensizeIcon } from "../Icons/ScreenSizeIcons";


export default function GridAreaField({ layoutObject, updateFunc, screenSize, saveFunc }: { layoutObject: LayoutNode, updateFunc: UpdateStyleFunction, screenSize: ScreenSize, saveFunc: Function }) {

    const [toggleUpdate, setToggleUpdate] = useState(false);
    const leftRef = useRef<HTMLInputElement>(null);
    const rightRef = useRef<HTMLInputElement>(null);
    const topRef = useRef<HTMLInputElement>(null);
    const bottomRef = useRef<HTMLInputElement>(null);

    const [isUpdated, setIsUpdated] = useState(getNodeStyleAttributeValue(layoutObject, screenSize, gridAttributes.gridArea, "").length > 1);
    const update = (str?:string) => {

        if (str) {
           let aData = GetGridAreaDataFromStr(str);
            if(leftRef.current){
                leftRef.current.value = aData.xStart.toString();
            }
            if(rightRef.current){
                rightRef.current.value = aData.xEnd.toString();
            }
            if(topRef.current){
                topRef.current.value = aData.yStart.toString();
            }
            if(bottomRef.current){
                bottomRef.current.value = aData.yEnd.toString();
            }

            if(str.length > 1){
                setIsUpdated(true);
            }
            else{
                setIsUpdated(false);
            }

        }

        else{
        setToggleUpdate(!toggleUpdate);

        }
    }



    (window as any).updateGridAreaUI = update;

    const initAreaData = GetGridAreaDataFromNode(layoutObject, screenSize);

    let gridArea = getNodeStyleAttributeValue(layoutObject, screenSize, gridAttributes.gridArea, "");
    let gridRenderData = GetGridRenderData(layoutObject.parent ?? layoutObject, screenSize);

    const absoluteLabelStyle = {
        position:"absolute",
        top: "-28px",
        width:"100%",
        left: "0",
        color:"#777",
        textAlign:"center",
        fontWeight:"500"


    } as React.CSSProperties;

    return (
        <div className="wb-input-group no-border" style={{marginTop:"6px"}} >

        <label className={(gridArea.length > 1) ? "updated" : ""} >    <span className="icon-label"><GetScreensizeIcon screenSize={screenSize} />{"Grid Position"}</span></label>
            <div key={toggleUpdate + "grid"+screenSize} className="relative" style={{  width: "200px", height: "174px", margin: "26px auto 0", display: "grid", gridTemplateColumns: "repeat(3,1fr)", gridTemplateRows: "repeat(3,1fr)" }}>

                <div id='area-top' className="flex-column justify-end relative" style={{ gridArea: "1 / 2 / 2 / 3", padding: "4px", border: " 1px dashed #c7c7c7", borderWidth: "0 1px 0 1px" }} >
                <label style={{...absoluteLabelStyle,top:"-16px"}}>Top</label>
                    <NumInput inRef={topRef} autoVal={0} min={1} max={Math.min(gridRenderData.rowCount, initAreaData.yEnd)} inVlaue={initAreaData.yStart.toString()} onUpdate={(num) => {
                        let areaData = GetGridAreaDataFromNode(layoutObject, screenSize);
                        let str = `${num}/${areaData.xStart}/${areaData.yEnd}/${areaData.xEnd}`;
                        updateFunc(gridAttributes.gridArea, str, AttributeTargetType.Style);
                        setIsUpdated(true);


                    }} />
                </div>
                <div id='area-bottom' className="flex-column justify-start relative" style={{ gridArea: "3 / 2 / 4 / 3", padding: "4px", border: " 1px dashed #c7c7c7", borderWidth: "0 1px 0 1px" }} >
                 {(screenSize==ScreenSize.Desktop||!isUpdated) && <label style={absoluteLabelStyle}>Bottom</label> }
                    <NumInput inRef={bottomRef} autoVal={0} min={Math.max(1, initAreaData.yStart)} max={gridRenderData.rowCount} inVlaue={initAreaData.yEnd.toString()} onUpdate={(num) => {
                        let areaData = GetGridAreaDataFromNode(layoutObject, screenSize);
                        let str = `${areaData.yStart}/${areaData.xStart}/${num}/${areaData.xEnd}`;
                        updateFunc(gridAttributes.gridArea, str, AttributeTargetType.Style);
                        setIsUpdated(true);

                    }} />

                </div>
                <div id='area-left' className="center-all relative" style={{ gridArea: "2 / 1 / 3 / 2", padding: "4px", border: " 1px dashed #c7c7c7", borderWidth: "1px 0  1px 0" }}>
                    <label style={absoluteLabelStyle}>Left</label>
                    <NumInput inRef={leftRef} autoVal={0} min={1} max={Math.min(gridRenderData.colCount, initAreaData.xEnd)} inVlaue={initAreaData.xStart.toString()} onUpdate={(num) => {
                        let areaData = GetGridAreaDataFromNode(layoutObject, screenSize);
                        let str = `${areaData.yStart}/${num}/${areaData.yEnd}/${areaData.xEnd}`;
                        updateFunc(gridAttributes.gridArea, str, AttributeTargetType.Style);
                        setIsUpdated(true);

                    }} />
                </div>
                <div id='area-right'  className="center-all relative" style={{ gridArea: "2 / 3 / 3 / 4", padding: "4px", border: " 1px dashed #c7c7c7", borderWidth: "1px 0  1px 0" }}>
                <label style={absoluteLabelStyle}>Right</label>
                    <NumInput inRef={rightRef} autoVal={0} min={Math.max(1, initAreaData.xStart)} max={gridRenderData.colCount} inVlaue={initAreaData.xEnd.toString()} onUpdate={(num) => {
                        let areaData = GetGridAreaDataFromNode(layoutObject, screenSize);
                        let str = `${areaData.yStart}/${areaData.xStart}/${areaData.yEnd}/${num}`;
                        updateFunc(gridAttributes.gridArea, str, AttributeTargetType.Style);
                        setIsUpdated(true);

                    }} />

                </div>


                <div className="center-all" style={{ gridArea: "2 / 2 / 3 / 3", border: " 1px dashed #c7c7c7",padding:"4px" }}>

                    {screenSize !== ScreenSize.Desktop && isUpdated &&
                        <button
                            className="w-button w-button-ghost h-full w-full center-all"
                            style={{ color: "var(--input-selected-primary)" }}
                            onClick={() => {
                                updateFunc(gridAttributes.gridArea, "", AttributeTargetType.Style);
                                saveFunc();
                                update();
                                setIsUpdated(false);
                            }}
                        >Clear</button>

                    }
                </div>


            </div>


        </div>

    )


}


export function NumInput({ inVlaue, min, max, onUpdate, clsAdd, autoVal, unitString,inRef,placeHolder,debounce }: {debounce?:boolean,placeHolder?:string, inRef?:any, unitString?: string, autoVal: number, clsAdd?: string, min: number, max: number, inVlaue: string, onUpdate: (num: string) => void }) {

    const prevVal = useRef<string>(inVlaue);
    const debounceRef = useRef<any>(null);
    const usingKeyBoard = useRef<boolean>(false);
    const mouseClickTop = useRef<boolean>(false);

    return (

        <div className="range-text w-full relative" style={{ margin: "0" }} >

            <input onPointerDown={(e:any)=>{

                let target = e.target as HTMLInputElement;
                let mousey  = e.clientY;
                let targetRect = target.getBoundingClientRect();
                if(mousey<targetRect.top+targetRect.height/2){
                    mouseClickTop.current = true;
                }
                else{
                    mouseClickTop.current = false;
                }

                usingKeyBoard.current = false

            }} onKeyDown={()=>{usingKeyBoard.current = true}} ref={inRef} className={(clsAdd ?? "")} placeholder={placeHolder??"Auto"} style={{ width: "100%" }} type="number" defaultValue={inVlaue} min={min} max={max} onChange={(e) => {

                if(debounceRef.current){
                    clearTimeout(debounceRef.current);
                }
                if(debounce && usingKeyBoard.current){
                    debounceRef.current = setTimeout(() => {
                        let newVal = e.target.value;
                        prevVal.current = newVal;
                        onUpdate(newVal);
                    }, 400);
                }
                else{
                    if(prevVal.current == e.target.value){
                        return;
                    }
                    let newVal = e.target.value;
                    if(!usingKeyBoard.current&&prevVal.current == ""){
                            let nV = autoVal;
                            if(mouseClickTop.current){
                                nV = Math.min(nV+1,max);
                            }
                            else{
                                nV = Math.max(nV-1,min);
                            }
                            newVal = nV.toString();
                            e.target.value = newVal;
                    }


                    prevVal.current = newVal;
                    onUpdate(newVal);
                }



            }} />
            {unitString && <div>{unitString}</div>}
        </div>

    )

}


function SendToBackIcon(){

    return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" viewBox="0 0 640 512"><path d="M256 208V48a48 48 0 0 0 -48-48H48A48 48 0 0 0 0 48v160a48 48 0 0 0 48 48h160a48 48 0 0 0 48-48zM48 48h160v160H48zm384 176h48v-80a48 48 0 0 0 -48-48H288v48h144zM96 160h64V96H96zm496 96H432a48 48 0 0 0 -48 48v160a48 48 0 0 0 48 48h160a48 48 0 0 0 48-48V304a48 48 0 0 0 -48-48zm0 208H432V304h160zM208 288h-48v80a48 48 0 0 0 48 48h144v-48H208zm336 64h-64v64h64z"/></svg>

}

function BringToFrontIcon(){

    return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" viewBox="0 0 640 512"><path d="M480 368V144a48 48 0 0 0 -48-48H208a48 48 0 0 0 -48 48v224a48 48 0 0 0 48 48h224a48 48 0 0 0 48-48zM208 144h224v224H208zM48 48h160v16h48V48a48 48 0 0 0 -48-48H48A48 48 0 0 0 0 48v160a48 48 0 0 0 48 48h80v-48H48zm544 208h-80v48h80v160H432v-16h-48v16a48 48 0 0 0 48 48h160a48 48 0 0 0 48-48V304a48 48 0 0 0 -48-48zM96 160h32v-16a79.2 79.2 0 0 1 16.4-48H96zm448 192h-32v16a79.2 79.2 0 0 1 -16.4 48H544z"/></svg>

}
